import { clsx } from 'clsx';
import { CSSProperties, forwardRef, PropsWithChildren } from 'react';
import styles from './Stack.module.scss';

type HStackProps = {
  align?: 'center' | 'start' | 'end';
  className?: string;
  gap?: 0.5 | 1 | 1.5 | 2 | 3 | 4 | 5;
  style?: CSSProperties;
  justify?: 'center' | 'start' | 'end' | 'space-between';
} & React.HTMLAttributes<HTMLDivElement>;

export const HStack = forwardRef<HTMLDivElement, PropsWithChildren<HStackProps>>(
  ({ align, children, className, gap, style, justify, ...dataAttrs }, ref) => {
    return (
      <div
        className={clsx(
          styles.hstack,
          {
            [styles.alignCenter!]: align === 'center',
            [styles.alignEnd!]: align === 'end',
            [styles.alignStart!]: align === 'start',
            [styles.justifyEnd!]: justify === 'end',
            [styles.justifyCenter!]: justify === 'center',
            [styles.justifyStart!]: justify === 'start',
            [styles.justifySpaceBetween!]: justify === 'space-between',
          },
          className,
        )}
        style={gap ? { ...style, gap: gap * 8 } : style}
        ref={ref}
        {...dataAttrs}
      >
        {children}
      </div>
    );
  },
);

HStack.displayName = 'HStack';

type VStackProps = {
  align?: 'center' | 'start' | 'end';
  justify?: 'center' | 'start' | 'end' | 'space-between';
  className?: string;
  gap?: 0.5 | 1 | 1.5 | 2 | 2.5 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  style?: CSSProperties;
} & React.HTMLAttributes<HTMLDivElement>;

export const VStack = forwardRef<HTMLDivElement, PropsWithChildren<VStackProps>>(
  ({ align, justify, children, className, gap, style, ...dataAttrs }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          styles.vstack,
          {
            [styles.alignCenter!]: align === 'center',
            [styles.alignStart!]: align === 'start',
            [styles.alignEnd!]: align === 'end',
            [styles.justifyEnd!]: justify === 'end',
            [styles.justifyCenter!]: justify === 'center',
            [styles.justifyStart!]: justify === 'start',
            [styles.justifySpaceBetween!]: justify === 'space-between',
          },
          className,
        )}
        style={gap ? { ...style, gap: gap * 8 } : style}
        {...dataAttrs}
      >
        {children}
      </div>
    );
  },
);

VStack.displayName = 'VStack';
